import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Intervenant } from 'src/app/model/gestion/gestion';
import { WebConfigurationService } from '../common/web-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class GestionIntervenantsSavService extends WebConfigurationService {

  constructor(protected http: HttpClient) {
    super(http);
  }

  /**
  * GET intervenants sav datas
  * 
  */
  public getIntervenantsSav(): Observable<any> {
    return this.authGetObs<Intervenant[]>(this.getIntervenantsSavUrl());
  }

  /**
  * GET intervenants sav datas
  * 
  */
  public getDepartementsList(): Observable<any> {
    return this.authGetObs<any[]>(this.getDepartementUrl());
  }


  /**
* POST an intervenant sav
* @returns  an Observable
*/
  public postIntervenantSav(newIntervenantSav: Intervenant): Observable<any> {
    return this.http.post<Intervenant>(this.getIntervenantsSavUrl(), newIntervenantSav, {
      headers: this.createHeaders( )
    });
  }

  /** UPDATE an intervenant */
  public editIntervenantSav(id: number, body: Intervenant) {
    let url = this.getIntervenantsSavUrl() + '/update/' + id;
    return this.authPutObs<Intervenant>(url, body);
  }

  /** DELETE intervenant */
  public deleteIntervenantSav(id: number, body: Intervenant) {
    let url = this.getIntervenantsSavUrl() + '/delete/' + id;
    return this.authPutObs<Intervenant>(url, body);
  }



}
